const dt = new Date();

export default {
  id: {
    dbKey: 'id',
    type: 'string',
    displayName: 'ID',
  },
  email: {
    dbKey: 'email',
    type: 'string',
    displayName: 'Email',
    validationRules: [
      value => (!!value || (value && false)) || 'Required.',
      function (value) {
        const regex = new RegExp('[^\\s@]+@[^\\s@]+\\.[^\\s@]+', 'gi');
        return regex.test(value) || 'Please enter a valid email address';
      },
    ],
  },
  password: {
    dbKey: 'password',
    type: 'string',
    displayName: 'Password',
    validationRules: [
      value => (!!value || (value && false)) || 'Required.',
      function (value) {
        const regex = new RegExp('^(?=.*[!@#$%^&*-])(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,20}$');
        return regex.test(value) || 'Use 8-20 characters with capital and small letters, numbers and special characters.';
      },
    ],
  },
  name: {
    dbKey: 'name',
    type: 'string',
    displayName: 'Customer name',
    validationRules: [
      value => (!!value || (value && false)) || 'Required.',
      value => (value && value.length <= 32) || 'Max 32 characters',
    ],
  },
  customerMemberships: {
    dbKey: 'customerMemberships',
    type: 'array',
    displayName: 'Account membership',
  },
  timestamp: {
    dbKey: 'timestamp',
    type: 'string',
    displayName: 'Timestamp',
  },
  mock: {
    id: '',
    email: '',
    password: '',
    name: '',
    customerMemberships: [
      {
        locked: true,
        accountId: '',
      },
    ],
    timestamp: dt.toISOString(),
  },
};
